import { CourseListItemUser } from '../../../../lib/interfaces/courses';
import { Button } from '../../../../ui/components/ui/button';
import { COURSE_COVER, COURSE_COVER_FALLBACK, COURSE_COVER_TRACK_COLOR } from '../../constants/course-cover';
import { CircularProgress } from '../circular-progress/circular-progress';

export interface CourseCardProps {
  course: CourseListItemUser;
  /**
   * Progress between 0 and 100. Will be wired to real tracking in v2 – default 0.
   */
  percentage?: number;
  onOpen: (course: CourseListItemUser) => void;
  isPreview?: boolean;
}

const CourseCard = ({ course, percentage = 0, onOpen, isPreview = false }: CourseCardProps) => {
  const isComplete = percentage >= 100;
  const isCurrent = !isComplete && percentage > 0;

  return (
    <div
      className="bg-white rounded-2xl border border-[#E4E7EC] px-5 py-5 flex items-center gap-5"
      style={{ boxShadow: '0px 4px 12.7px 0px rgba(0, 0, 0, 0.04)' }}>
      <CircularProgress
        size={COURSE_COVER.lg.size}
        percentage={percentage}
        bgColor="#ffffff"
        bgTrackColor={COURSE_COVER_TRACK_COLOR}
        strokeWidth={COURSE_COVER.lg.strokeWidth}
        imgUrl={course.imageUrl ?? COURSE_COVER_FALLBACK}
        animate="forward"
      />

      <div className="flex-1 min-w-0 flex flex-col gap-2">
        <div className="flex items-center gap-2">
          {isComplete && !isPreview && (
            <span
              className="text-[11px] font-semibold px-2 py-1 rounded-full text-white"
              style={{ background: 'linear-gradient(135deg, #5FD5DE 0%, #C0DE60 100%)' }}>
              ✓ Abgeschlossen
            </span>
          )}
          {isCurrent && <span className="text-[11px] font-semibold px-2 py-1 rounded-full bg-[#F0F4FC] text-[#12282A]">Aktueller Kurs</span>}
        </div>
        <h3 className="text-[18px] font-bold text-[#12282A] truncate">{course.title}</h3>
        <div>
          <Button variant="outline" size="sm" onClick={() => onOpen(course)} disabled={isPreview}>
            {isCurrent ? 'Weiterlernen' : 'Lektionen aufrufen'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;

export const CourseCardSkeleton = () => (
  <div
    className="bg-white rounded-2xl border border-[#E4E7EC] px-5 py-5 flex items-center gap-5 animate-pulse"
    style={{ boxShadow: '0px 4px 12.7px 0px rgba(0, 0, 0, 0.04)' }}>
    <div className="rounded-full bg-[#E4E7EC]" style={{ width: COURSE_COVER.lg.size, height: COURSE_COVER.lg.size }} />
    <div className="flex-1 flex flex-col gap-2">
      <div className="h-3 w-20 bg-[#E4E7EC] rounded-full" />
      <div className="h-5 w-40 bg-[#E4E7EC] rounded-full" />
      <div className="h-8 w-32 bg-[#E4E7EC] rounded-full" />
    </div>
  </div>
);
